<div [bodyClass]="'avia-page'" class="avia-list">
    @if (isShowErrors) {
        <app-avia-not-found [filtered]="isEmptyFilteredResults" (changeFilters)="aviaFilters.showAllFilters()"/>
    } @else {
        <app-search-progress-linear [type]="'line-note'"/>
    }

    <app-avia-filters #aviaFilters [searchId]="searchId" [initialFiltersRequest]="restoredFiltersRequest"
                      (applyFilters)="applyAviaFilters($event)"/>

    @if (!isShowErrors && !aviaItineraries?.length) {
        <div class="avia-list__skeleton">
            <app-avia-card-skeleton/>
        </div>
    }

    @for (itinerary of aviaItineraries; track itinerary.id) {
        <app-avia-card
                [itinerary]="itinerary"
                [searchId]="searchId"
                [isBestPrice]="isBestPrice(itinerary)"/>
    }
</div>
